import ErrorFallback from 'Components/ErrorFallback'
import {
  SalesPointCreatePage,
  SalesPointEditPage,
  SalesPointListPage
} from 'Services/ServiceProviderManagement/Features/SalesPoint/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

export function SalesPointRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<SalesPointListPage />} />
        <Route path="create" element={<SalesPointCreatePage />} />
        <Route path=":pta/:id/edit" element={<SalesPointEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
